import React from "react";
import Modal from "react-modal";
import {
  BENEFIT_SHEET_TABS,
  MOCK_CAR_RULES_BULLETS,
  MOCK_CAR_RULES_TITLE,
  MOCK_TNDS_CAR_BULLETS,
  MOCK_TNDS_CAR_TITLE,
  benefitSheetModalStyles,
} from "../constants";
import BenefitBulletList from "./BenefitBulletList";

export default function CarBenefitSheetModal({
  isOpen,
  onClose,
  activeTab = BENEFIT_SHEET_TABS.detail,
  onTabChange,
}) {

  const isDetail = activeTab === BENEFIT_SHEET_TABS.detail;
  const isRules = activeTab === BENEFIT_SHEET_TABS.rules;

  const TAB_IDS = {
    detail: "fe-sheet-tab-detail",
    rules: "fe-sheet-tab-rules",
  };

  const PANEL_IDS = {
    detail: "fe-sheet-panel-detail",
    rules: "fe-sheet-panel-rules",
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={benefitSheetModalStyles}
      contentLabel="Chi tiết quyền lợi và quy tắc"
      closeTimeoutMS={220}
    >
      <div className="car-insurance__sheet">
        <div className="car-insurance__sheet-handle" aria-hidden />
        <button
          type="button"
          className="car-insurance__sheet-close"
          onClick={onClose}
          aria-label="Đóng"
        >
          ×
        </button>
        <div
          className="car-insurance__sheet-tabs"
          role="tablist"
          aria-label="Nội dung chi tiết bảo hiểm"
        >
          <button
            id={TAB_IDS.detail}
            type="button"
            role="tab"
            aria-selected={isDetail}
            aria-controls={PANEL_IDS.detail}
            className={`car-insurance__sheet-tab${isDetail ? " car-insurance__sheet-tab--active" : ""
              }`}
            tabIndex={isDetail ? 0 : -1}
            onClick={() => onTabChange(BENEFIT_SHEET_TABS.detail)}
          >
            Quyền lợi bảo hiểm
          </button>

          <button
            id={TAB_IDS.rules}
            type="button"
            role="tab"
            aria-selected={isRules}
            aria-controls={PANEL_IDS.rules}
            className={`car-insurance__sheet-tab${isRules ? " car-insurance__sheet-tab--active" : ""
              }`}
            tabIndex={isRules ? 0 : -1}
            onClick={() => onTabChange(BENEFIT_SHEET_TABS.rules)}
          >
            Quy tắc &amp; Loại trừ
          </button>
        </div>
        <div
          id={PANEL_IDS.detail}
          role="tabpanel"
          className="car-insurance__sheet-body"
          aria-labelledby={TAB_IDS.detail}
          hidden={!isDetail}
        >
          <h3 className="car-insurance__sheet-panel-title">
            {MOCK_TNDS_CAR_TITLE}
          </h3>
          <BenefitBulletList items={MOCK_TNDS_CAR_BULLETS} />
        </div>
        <div
          id={PANEL_IDS.rules}
          role="tabpanel"
          className="car-insurance__sheet-body"
          aria-labelledby={TAB_IDS.rules}
          hidden={!isRules}
        >
          <h3 className="car-insurance__sheet-panel-title">
            {MOCK_CAR_RULES_TITLE}
          </h3>
          <BenefitBulletList items={MOCK_CAR_RULES_BULLETS} />
        </div>
        <div className="car-insurance__sheet-footer">
          <button
            type="button"
            className="car-insurance__sheet-understood-btn"
            onClick={onClose}
          >
            Đã hiểu
          </button>
        </div>
      </div>
    </Modal>
  );
}
